export default __webpack_public_path__ + "static/media/setting-icon.07d2fab0.svg";